<a
  tabindex="0"
  (click)="onClickGoBackButton()"
  (keypress)="onClickGoBackButton()"
  class="cursor-pointer inline-flex items-center border-solid border-gray-300 px-2 py-1 rounded-md text-gray-700 hover:bg-gray-200 text-sm"
>
  <mat-icon>arrow_back</mat-icon>
  <span class="ml-1 font-semibold text-sm">{{
    'GENERAL.back' | translate
  }}</span>
</a>
